(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./ModernBoard.less", "./ModernBoardKey", "../button"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./ModernBoard.less"), require("./ModernBoardKey"), require("../button"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.ModernBoard, global.ModernBoardKey, global.button);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _ModernBoard, _ModernBoardKey, _button) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _ModernBoardKey = _interopRequireDefault(_ModernBoardKey);
  _button = _interopRequireDefault(_button);
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "modern-board"
      }, [_c('div', {
        staticClass: "board-col-1"
      }, [_c('div', {
        staticClass: "key-row"
      }, [_c('key', {
        attrs: {
          "value": "1"
        },
        on: {
          "press": _vm.handlePress
        }
      }), _c('key', {
        attrs: {
          "value": "2"
        },
        on: {
          "press": _vm.handlePress
        }
      }), _c('key', {
        attrs: {
          "value": "3"
        },
        on: {
          "press": _vm.handlePress
        }
      })], 1), _c('div', {
        staticClass: "key-row"
      }, [_c('key', {
        attrs: {
          "value": "4"
        },
        on: {
          "press": _vm.handlePress
        }
      }), _c('key', {
        attrs: {
          "value": "5"
        },
        on: {
          "press": _vm.handlePress
        }
      }), _c('key', {
        attrs: {
          "value": "6"
        },
        on: {
          "press": _vm.handlePress
        }
      })], 1), _c('div', {
        staticClass: "key-row"
      }, [_c('key', {
        attrs: {
          "value": "7"
        },
        on: {
          "press": _vm.handlePress
        }
      }), _c('key', {
        attrs: {
          "value": "8"
        },
        on: {
          "press": _vm.handlePress
        }
      }), _c('key', {
        attrs: {
          "value": "9"
        },
        on: {
          "press": _vm.handlePress
        }
      })], 1), _c('div', {
        staticClass: "key-row"
      }, [_vm.showId ? _c('div', {
        staticClass: "two-press id-key"
      }, [_c('key', {
        attrs: {
          "value": "X"
        },
        on: {
          "press": _vm.handlePress
        }
      }), _c('key', {
        attrs: {
          "value": "0"
        },
        on: {
          "press": _vm.handlePress
        }
      })], 1) : _vm.showNum ? _c('div', {
        staticClass: "two-press"
      }, [_c('key', {
        attrs: {
          "value": "0"
        },
        on: {
          "press": _vm.handlePress
        }
      }), _c('key', {
        attrs: {
          "value": "00"
        },
        on: {
          "press": _vm.handlePress
        }
      })], 1) : _vm.hideDot ? [_c('key', {
        attrs: {
          "hide-content": "",
          "no-touch": ""
        },
        on: {
          "press": _vm.handlePress
        }
      }), _c('key', {
        attrs: {
          "value": "0"
        },
        on: {
          "press": _vm.handlePress
        }
      }), _c('key', {
        staticClass: "key-dot",
        attrs: {
          "value": ".",
          "hide-content": _vm.hideDot,
          "no-touch": _vm.hideDot
        },
        on: {
          "press": _vm.handlePress
        }
      })] : _c('div', {
        staticClass: "two-press"
      }, [_c('key', {
        attrs: {
          "value": "0"
        },
        on: {
          "press": _vm.handlePress
        }
      }), _c('key', {
        staticClass: "key-dot",
        attrs: {
          "value": "."
        },
        on: {
          "press": _vm.handlePress
        }
      })], 1)], 2)]), _c('div', {
        staticClass: "board-col-2"
      }, [_c('key', {
        staticClass: "key-del",
        attrs: {
          "value": "#",
          "ariaKeyStatus": false
        },
        on: {
          "press": _vm.handlePress
        }
      }, [_c('div', {
        staticClass: "del-icon",
        attrs: {
          "aria-label": "删除",
          "role": "button"
        }
      })]), _c('key', {
        attrs: {
          "no-touch": "",
          "no-prevent": ""
        }
      }, [_c('nx-button', {
        staticClass: "confirm-btn",
        attrs: {
          "size": "large",
          "type": "primary"
        },
        on: {
          "click": _vm.handleConfirm
        }
      }, [_vm._v("\n        确"), _c('br'), _vm._v("定\n      ")])], 1)], 1)]);
    },
    name: 'modern-board',
    components: (0, _defineProperty2.default)({
      Key: _ModernBoardKey.default
    }, _button.default.name, _button.default),
    props: {
      hideDot: {
        type: Boolean,
        default: false
      },
      showNum: {
        type: Boolean,
        default: false
      },
      showId: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      handlePress: function handlePress(_char) {
        if (this.hideDot && _char === '.') return;

        if (_char === '#') {
          this.$emit('delete');
        }

        this.$emit('input', _char);
      },
      handleConfirm: function handleConfirm() {
        this.$emit('confirm');
      }
    }
  };
  _exports.default = _default;
});